import { PostInstallationMedia } from "../../../types/responseTypes";
import { AdditionalWork } from "../../../types/provisionalTypes";

export const provisionalHomePictures: PostInstallationMedia = {
    media: [
        {
        mediaId: "1",
        type: "image",
        url: "https://www.labodegasolar.com/cdn/shop/articles/placas-solares-tejado-thinkstock-getty-1662535982.jpg?v=1667323017",
        },
        {
        mediaId: "2",
        type: "image",
        url: "https://lavozdemaipu.cl/wp-content/uploads/2024/03/casa-solar-1.jpg",
        },
        {
        mediaId: "3",
        type: "image",
        url: "https://www.labodegasolar.com/cdn/shop/articles/portada.jpg?v=1684358289",
        },
        {
        mediaId: "4",
        type: "image",
        url: "https://solinc.com.mx/wp-content/uploads/2022/02/img-solinc-ejemplos-casas-paneles-solares-01.jpg",
        },
    ],
};

export const provisionalAdditionalWorks: AdditionalWork[] = [
    {
        title: "Estructura de inclinación",
        description: "La presencia de esta estructura permite que los paneles solares estén inclinados para captar la mayor cantidad de luz solar posible.",
        imageUrl: "https://teycubermadera.com/readcontents.php?file=webstructure/20100225084112.jpg",
    },
    {
        title: "Zanja y/o canalización",
        description: "Se realiza una zanja para canalizar los cables de los paneles solares, impidiendo daños a los circuitos y mejorando la vida útil de tu instalación.",
        imageUrl: "https://cdn.shopify.com/s/files/1/0552/7361/9543/files/canaletas-pluviales-lamina-galvanizada_480x480.jpg?v=1661199698",
    },
    {
        title: "Aumento de empalme",
        description: "Se realiza un aumento de empalme para conectar los paneles solares a la red eléctrica de tu hogar.",
        imageUrl: "https://cl.habcdn.com/photos/business/medium/20170322-174026-604523.jpg",
    },
];

